import http from '@/http'
import { PartCodeDto } from '@/interfaces/admin'

export async function getPartCodes(): Promise<PartCodeDto[]> {
    const { data } = await http.get('/admin/part-codes')
    return data
}